const ET_TIME = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  hour: 'numeric',
  minute: '2-digit',
});

export function formatEtTime(ms: number): string {
  return ET_TIME.format(new Date(ms));
}

export function formatEtRange(startTs: number, endTs: number): string {
  return `${formatEtTime(startTs)} – ${formatEtTime(endTs)}`;
}
